module.exports = __webpack_public_path__ + "img/DoctorPlaceHolder.9b0757ac.png";